/**
 * @param {string[]} acceptedTypes list of accepted file extensions (pdf,jpg,jpeg)
 * @param {Object[]} allTypes list of all possible file types
 * @returns {string} comma separated string of the file type labels (PDF, JPG)
 */
export const getFileTypeLabels = (acceptedTypes = [], allTypes = []) =>
  allTypes
    ?.filter((type) => type?.extensions?.some((ext) => acceptedTypes.includes(ext)))
    .map((type) => type?.label)
    .join(', ');

/**
 * @param {string[]} acceptedTypes list of accepted file extensions (pdf,jpg,jpeg)
 * @param {Object[]} allTypes list of all possible file types
 * @returns {string} comma separated string of the file type labels (PDF, JPG)
 */
export const getAcceptedMimeTypes = (acceptedTypes = [], allTypes = []) =>
  allTypes
    ?.filter((type) => type?.extensions?.some((ext) => acceptedTypes.includes(ext)))
    .reduce((acc, item) => {
      item.mimeTypes.forEach((mimeType) => {
        if (!acc[mimeType]) {
          acc[mimeType] = [];
        }
        acc[mimeType].push(...item.extensions.map((ext) => `.${ext}`));
      });
      return acc;
    }, {});



// WEBPACK FOOTER //
// ./src/utils/fileTypes.js